import axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import SmallLoader from "@shared/components/Atoms/Loading/SmallLoading";
import { APP_NAME } from "@shared/util/brand";
import { BRAND } from "@shared/brand";
import CondenseLogo from "@shared/components/Atoms/CondenseLogo";
import NewzAgentLogo from "@shared/components/Atoms/NewzAgentLogo";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      setLoading(true);
      const button = document.querySelector("#forgot_btn");
      if (button) {
        button.textContent = "Sending Reset Link ...";
        button.disabled = true;
      }
      const res = await axios.post(
        `${import.meta.env.VITE_API_URL}/auth/request-reset`,
        { email }
      );
      if (res?.data) {
        setStep(2);
      }
    } catch (err) {
      console.error(err);
      setError(
        err?.response?.data?.msg ||
          err?.response?.data?.error ||
          "An error occurred. Please try again."
      );
    } finally {
      setLoading(false);
      const button2 = document.querySelector("#forgot_btn");
      if (button2) {
        button2.textContent = "Send Reset Link";
        button2.disabled = false;
      }
    }
  };

  const handleTryAgain = () => {
    setEmail("");
    setStep(1);
  };

  const contactHint =
    BRAND.id === "condense"
      ? "condense.tv"
      : BRAND.id === "newzagent"
        ? "newzagent.tv"
        : BRAND.footer?.email || "support";

  if (BRAND.id === "condense") {
    return (
      <>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
          .cd-auth {
            min-height: 100vh;
            background-color: #11141B;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            overflow: hidden;
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            padding: 24px 16px;
          }
          .cd-auth-glow {
            position: absolute;
            top: -15%;
            left: 50%;
            transform: translateX(-50%);
            width: 900px;
            height: 500px;
            background: radial-gradient(ellipse, rgba(24, 216, 137, 0.1) 0%, transparent 70%);
            filter: blur(100px);
            pointer-events: none;
          }
          .cd-auth-card {
            position: relative;
            z-index: 1;
            width: 100%;
            max-width: 420px;
            padding: 40px 32px 36px;
            background: #1C2029;
            border: 1px solid rgba(245,247,248,0.10);
            border-radius: 16px;
            box-shadow: 0 20px 60px -20px rgba(0,0,0,.5);
            text-align: center;
          }
          .cd-auth-logo { display: flex; justify-content: center; margin-bottom: 28px; }
          .cd-auth-card h1 { margin: 0 0 8px; font-size: 22px; font-weight: 600; color: #F5F7F8; }
          .cd-auth-card p { margin: 0 0 20px; font-size: 14px; color: #929AA7; line-height: 1.5; }
          .cd-auth-card label { display: block; text-align: left; margin-bottom: 6px; font-size: 14px; font-weight: 500; color: #929AA7; }
          .cd-auth-card input {
            width: 100%; padding: 14px 16px; background: #11141B;
            border: 1px solid rgba(245,247,248,0.10); border-radius: 10px; color: #F5F7F8;
            font-size: 15px; font-family: Inter, sans-serif; text-transform: none; letter-spacing: 0; outline: none; transition: border-color 0.2s; box-sizing: border-box;
          }
          .cd-auth-card input::placeholder { color: #6d7582; }
          .cd-auth-card input:focus { border-color: rgba(24, 216, 137, 0.7); }
          .cd-auth-field { margin-bottom: 18px; text-align: left; }
          .cd-auth-error {
            background: rgba(220,38,38,0.15); border: 1px solid rgba(220,38,38,0.3);
            color: #fca5a5; padding: 10px 14px; border-radius: 10px; font-size: 14px; margin-bottom: 14px;
          }
          .cd-auth-btn {
            width: 100%; padding: 14px; background: #18D889; color: #11141B; font-size: 16px; font-weight: 600;
            border: none; border-radius: 10px; cursor: pointer;
          }
          .cd-auth-btn:hover { background: #14c47a; }
          .cd-auth-btn:disabled { opacity: 0.7; cursor: not-allowed; transform: none; }
          .cd-auth-link { display: inline-block; margin-top: 18px; color: #929AA7; font-size: 14px; text-decoration: none; }
          .cd-auth-link:hover { color: #F5F7F8; }
          .cd-auth-email { color: #52F2AE; font-weight: 600; }
          .cd-auth-hint {
            text-align: left; font-size: 13px; color: #94a3b8; background: rgba(255,255,255,0.04);
            border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; padding: 14px 16px; margin: 0 0 16px;
          }
          .cd-auth-hint ul { margin: 8px 0 0; padding-left: 18px; }
          .cd-auth-success {
            width: 64px; height: 64px; margin: 0 auto 20px; border-radius: 9999px;
            background: #18D889; color: #11141B; display: flex; align-items: center; justify-content: center; font-size: 28px;
          }
        `}</style>
        <div className="cd-auth">
          <div className="cd-auth-glow" />
          <div className="cd-auth-card">
            <div className="cd-auth-logo">
              <Link to="/">
                <CondenseLogo height={28} color="#F5F7F8" />
              </Link>
            </div>
            {step === 1 && (
              <>
                <h1>Forgot Password?</h1>
                <p>Enter your email to reset your password</p>
                <form onSubmit={handleForgotSubmit}>
                  <div className="cd-auth-field">
                    <label htmlFor="forgot-email">Email Address</label>
                    <input
                      id="forgot-email"
                      type="email"
                      placeholder="your@email.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  {error && <div className="cd-auth-error">{error}</div>}
                  {loading && (
                    <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
                      <SmallLoader />
                    </div>
                  )}
                  <button type="submit" id="forgot_btn" className="cd-auth-btn">
                    Send Reset Link
                  </button>
                </form>
                {/* Full page load: /login is served by the app SPA (.htaccess), not public routes */}
                <a href="/login" className="cd-auth-link">
                  Back to Sign In
                </a>
              </>
            )}
            {step === 2 && (
              <>
                <div className="cd-auth-success">✉️</div>
                <h1>Check Your Email</h1>
                <p>Reset link sent successfully</p>
                <p>
                  We&apos;ve sent a reset link to:
                  <br />
                  <span className="cd-auth-email">{email}</span>
                </p>
                <p>
                  Click the link in your email to reset your password. If you don&apos;t see it,
                  check your spam folder.
                </p>
                <div className="cd-auth-hint">
                  <strong style={{ color: "#e2e8f0" }}>Can&apos;t find the email?</strong>
                  <ul>
                    <li>Check your spam or junk mail folder</li>
                    <li>Make sure you entered the correct email address</li>
                    <li>Wait a few minutes — emails can sometimes be delayed</li>
                    <li>Add {contactHint} to your email contacts</li>
                  </ul>
                </div>
                <button type="button" className="cd-auth-link" onClick={handleTryAgain}>
                  Try Again
                </button>
              </>
            )}
          </div>
        </div>
      </>
    );
  }

  if (BRAND.id === "newzagent") {
    return (
      <>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Montserrat:wght@700;900&display=swap');
          .nz-auth {
            min-height: 100vh; background: #020617; display: flex; align-items: center; justify-content: center;
            position: relative; overflow: hidden; font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            padding: 24px 16px;
          }
          .nz-auth-glow {
            position: absolute; top: -15%; left: 50%; transform: translateX(-50%); width: 900px; height: 500px;
            background: radial-gradient(ellipse, rgba(127,29,29,0.35) 0%, transparent 70%); filter: blur(100px); pointer-events: none;
          }
          .nz-auth-card {
            position: relative; z-index: 1; width: 100%; max-width: 420px; padding: 40px 32px 36px;
            background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.10); border-radius: 20px;
            box-shadow: 0 20px 60px -20px rgba(0,0,0,.6); text-align: center;
          }
          .nz-auth-logo { display: flex; justify-content: center; margin-bottom: 28px; }
          .nz-auth-card h1 { margin: 0 0 8px; font-size: 22px; font-weight: 600; color: #f8fafc; }
          .nz-auth-card p { margin: 0 0 20px; font-size: 14px; color: #94a3b8; line-height: 1.5; }
          .nz-auth-card label { display: block; text-align: left; margin-bottom: 6px; font-size: 14px; font-weight: 500; color: #cbd5e1; }
          .nz-auth-card input {
            width: 100%; padding: 14px 16px; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.10);
            border-radius: 12px; color: #f8fafc; font-size: 15px; font-family: inherit; outline: none; box-sizing: border-box;
          }
          .nz-auth-card input:focus { border-color: rgba(220,38,38,0.6); }
          .nz-auth-field { margin-bottom: 18px; text-align: left; }
          .nz-auth-error {
            background: rgba(220,38,38,0.15); border: 1px solid rgba(220,38,38,0.3); color: #fca5a5;
            padding: 10px 14px; border-radius: 10px; font-size: 14px; margin-bottom: 14px;
          }
          .nz-auth-btn {
            width: 100%; padding: 14px; background: #dc2626; color: #fff; font-family: 'Montserrat', sans-serif;
            font-size: 16px; font-weight: 700; border: none; border-radius: 12px; cursor: pointer;
            box-shadow: 0 4px 15px rgba(220,38,38,0.3);
          }
          .nz-auth-btn:hover { background: #ef4444; }
          .nz-auth-link { display: inline-block; margin-top: 18px; color: #94a3b8; font-size: 14px; text-decoration: none; }
          .nz-auth-link:hover { color: #f8fafc; }
          .nz-auth-email { color: #fca5a5; font-weight: 600; }
          .nz-auth-hint {
            text-align: left; font-size: 13px; color: #94a3b8; background: rgba(255,255,255,0.04);
            border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; padding: 14px 16px; margin: 0 0 16px;
          }
          .nz-auth-hint ul { margin: 8px 0 0; padding-left: 18px; }
          .nz-auth-success {
            width: 64px; height: 64px; margin: 0 auto 20px; border-radius: 9999px; background: #dc2626; color: #fff;
            display: flex; align-items: center; justify-content: center; font-size: 28px;
          }
        `}</style>
        <div className="nz-auth">
          <div className="nz-auth-glow" />
          <div className="nz-auth-card">
            <div className="nz-auth-logo">
              <Link to="/">
                <NewzAgentLogo height={40} color="#ffffff" accentColor="#ef4444" />
              </Link>
            </div>
            {step === 1 && (
              <>
                <h1>Forgot Password?</h1>
                <p>Enter your email to reset your password</p>
                <form onSubmit={handleForgotSubmit}>
                  <div className="nz-auth-field">
                    <label htmlFor="forgot-email">Email Address</label>
                    <input
                      id="forgot-email"
                      type="email"
                      placeholder="your@email.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  {error && <div className="nz-auth-error">{error}</div>}
                  {loading && (
                    <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
                      <SmallLoader />
                    </div>
                  )}
                  <button type="submit" id="forgot_btn" className="nz-auth-btn">
                    Send Reset Link
                  </button>
                </form>
                <a href="/login" className="nz-auth-link">
                  Back to Sign In
                </a>
              </>
            )}
            {step === 2 && (
              <>
                <div className="nz-auth-success">✉️</div>
                <h1>Check Your Email</h1>
                <p>
                  We&apos;ve sent a reset link to:
                  <br />
                  <span className="nz-auth-email">{email}</span>
                </p>
                <div className="nz-auth-hint">
                  <strong style={{ color: "#e2e8f0" }}>Can&apos;t find the email?</strong>
                  <ul>
                    <li>Check your spam or junk mail folder</li>
                    <li>Make sure you entered the correct email address</li>
                    <li>Add {contactHint} to your email contacts</li>
                  </ul>
                </div>
                <button type="button" className="nz-auth-link" onClick={handleTryAgain}>
                  Try Again
                </button>
              </>
            )}
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center bg-gradient-to-br from-[#2563EB] via-[#1D4ED8] to-[#1E3A8A] p-5">
      <div className="text-white text-3xl font-semibold mt-5 mb-10">{APP_NAME}</div>
      <div className="bg-white rounded-2xl p-10 w-full max-w-md shadow-xl text-center">
        {step === 1 && (
          <div>
            <h1 className="text-2xl font-semibold text-[#1E3A8A] mb-2">Forgot Password?</h1>
            <p className="text-gray-600 mb-6">Enter your email to reset your password</p>
            <form onSubmit={handleForgotSubmit} className="text-left">
              <label className="block text-[#1E3A8A] font-medium mb-2">Email Address</label>
              <input
                type="email"
                className="w-full p-4 rounded-xl bg-gray-100 border-2 border-gray-200 focus:border-blue-500 focus:bg-white transition mb-6"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <div className="my-4">
                {error && (
                  <div className="bg-red-100 text-red-700 px-4 py-2 rounded text-sm text-center mb-2">
                    {error}
                  </div>
                )}
                {loading && <SmallLoader />}
              </div>
              <button
                type="submit"
                id="forgot_btn"
                className="w-full py-4 bg-gradient-to-br from-[#2563EB] via-[#1D4ED8] to-[#1E3A8A] text-white font-semibold rounded-xl hover:shadow-lg transition mb-4"
              >
                Send Reset Link
              </button>
            </form>
            <a className="text-blue-500 hover:underline text-sm" href="/login">
              Back to Sign In
            </a>
          </div>
        )}
        {step === 2 && (
          <div>
            <div className="w-20 h-20 mx-auto rounded-full bg-green-600 text-white flex items-center justify-center text-3xl mb-6">
              ✉️
            </div>
            <h1 className="text-2xl font-semibold text-[#1E3A8A] mb-2">Check Your Email</h1>
            <p className="text-gray-600 mb-4">
              We&apos;ve sent a reset link to: <br />
              <span className="text-[#1E3A8A] font-semibold">{email}</span>
            </p>
            <div className="text-sm text-gray-600 bg-gray-100 p-4 text-left rounded-lg mb-6">
              <strong>Can&apos;t find the email?</strong>
              <ul className="list-disc ml-6 mt-2">
                <li>Check your spam or junk mail folder</li>
                <li>Make sure you entered the correct email address</li>
                <li>Add {contactHint} to your email contacts</li>
              </ul>
            </div>
            <button className="text-gray-600 font-semibold rounded-xl mb-4" onClick={handleTryAgain}>
              Try Again
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
